var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactenos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#831131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43,28.5V51l-5.8-9.4l-16.1,7.9C12.7,53.7,7.3,62.4,7.5,71.7c0.2,13.1,6.6,34.7,35.2,63.5c13,11.8,32.5,28,52.2,31.9   c1.8,0.4,3.6,0.5,5.4,0.5c10.9,0,21-6.3,25.8-16.5l6.1-12.9l-30.6-19.7l-23.3,9.9L45.6,95l11.6-20.8L46,55.8V31.5h144.5v97.9h-53v3   h56V28.5H43z M41.9,95.5l35.7,36.5l23.7-10.1l27.1,17.4l-5,10.6c-5,10.6-16.5,16.5-27.9,14.3c-19-3.7-38.1-19.5-50.7-31.1   c-27.9-28.1-34.1-48.9-34.3-61.4c-0.2-8.1,4.5-15.7,11.9-19.4L36,45.5l17.7,28.7L41.9,95.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.1,109.6 104.7,84.4 116.8,94.7 129.3,84.4 161.9,109.6 163.7,107.2 131.7,82.4 175.8,46.1 173.9,43.8    116.8,90.8 61.1,43.1 59.2,45.4 102.4,82.4 70.3,107.2  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactenos);
export default __webpack_public_path__ + "static/media/contactenos.b57c4203824c7a2f7b31d3e3c5be274f.svg";
export { ForwardRef as ReactComponent };